import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import Clock from "@insite/mobius/Icons/Clock";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchHistoryStyles.headerText = {
    weight: "bold",
    css: css`
        text-align: left;
        margin: 10px 0 5px 0;
        color: ${getColor("secondary")};
    `,
};

searchHistoryStyles.icon = {
    src: Clock,
    css: css`
        margin-right: 10px;
        color: ${getColor("secondary")};
    `,
};

searchHistoryStyles.link = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 5px 0;
            color: ${getColor("secondary")}!important;
        `,
    },
    css: css`
        width: 100%;
        overflow: hidden;
    `,
};

searchHistoryStyles.clearLink = {
    typographyProps: {
        css: css`
            width: 100%;
            text-align: right;
            margin-top: 10px;
            color: ${getColor("secondary")}!important;
        `,
    },
};
